import {IHttpService} from "angular";
import {MarketMoversStateRecord} from "../types/MarketMoversState";

export class MarketMoversService {

    public static readonly id = "marketMoversService";

    /** @ngInject */
    public constructor(private readonly $http: IHttpService) {
    }

    public async latest(): Promise<MarketMoversStateRecord> {
        const url = "/tradefloor/api/market-movers";
        const response = await this.$http.get<MarketMoversStateRecord>(url);
        return response.data;
    }
}
